import type { PageResponse } from "../types";

export function MembershipPagination<T>({
  page,
  onPageChange,
}: {
  page?: PageResponse<T>;
  onPageChange: (page: number) => void;
}) {
  if (!page || page.totalPages <= 1) return null;

  return (
    <div className="mt-4 flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
      <p className="text-sm text-slate-500">
        Page <strong>{page.number + 1}</strong> of{" "}
        <strong>{page.totalPages}</strong> · {page.totalElements} records
      </p>

      <div className="flex gap-2">
        <button
          type="button"
          disabled={page.number === 0}
          onClick={() => onPageChange(page.number - 1)}
          className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Previous
        </button>

        <button
          type="button"
          disabled={page.number + 1 >= page.totalPages}
          onClick={() => onPageChange(page.number + 1)}
          className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}